import React from "react";
import { Link } from "react-router-dom";
import NKRHeader from "../Component/NKRHeader";
import NKRFooter from "../Component/NKRFooter";
import { getPrincipalMessage } from "../Service/Api";
import LazyLoad from "react-lazyload";
import { useState, useEffect } from "react";
function ChairpersonMessage() {
  useEffect(() => {
    document.title = "Chairperson Message -  Gayatri International School";
  }, []);
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const msgdata = await getPrincipalMessage();
        const data = msgdata.filter(
          (item) =>
            item.school === "NEKPUR" && item.category === "Vice Principal",
        );

        setData(data);
      } catch (error) {
        console.error("Error fetching online registration data:", error);
      }
    };
    fetchData();
  }, []);
  return (
    <>
      <NKRHeader />
      <section className="page-header-fb innerslide">
        <div className="innerslide">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/innerslide1.gif"
              className="img-fluid"
            />
          </LazyLoad>{" "}
        </div>
        <div className="page-header__inner">
          <h2>Chairperson's Message </h2>
          <ul className="thm-breadcrumb list-unstyled ml-0">
            <li>
              <Link to="/Nekhpur/Home">Home</Link>
            </li>
            <li>|</li>
            <li> Chairperson's Message </li>
          </ul>
        </div>
      </section>
      <section className="innerbody">
        <div className="container">
          <div className="row">
            {data.length > 0 && (
              <div className="clearfix">
                <LazyLoad>
                  {" "}
                  <img
                    src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0].attachments}`}
                    className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg"
                    alt={data[0].name || "Image"}
                  />
                </LazyLoad>
                <p>
                  <div dangerouslySetInnerHTML={{ __html: data[0].message }} />
                </p>
                <p className="name">
                  {data[0].name}
                  <span> Chairperson </span>
                </p>
              </div>
            )}

            {data.length === 0 && (
              <div className="clearfix">
                <LazyLoad>
                  {" "}
                  <img
                    src="Images/default.jpg"
                    className="img-fluid col-sm-12 col-md-3 float-md-end mb-3 msgimg"
                    alt=""
                  />
                </LazyLoad>
                <p>
                  <b>
                    "Every child is an artist. The problem is how to remain an
                    artist when we grow up"
                  </b>
                </p>
                <p>
                  Gayatri International School has set an ambitious goal for
                  itself to become one of the best day schools in Farrukhabad
                  and beyond. The school aspires to provide a well-rounded
                  education to pupils that will help them to acquire the
                  requisite knowledge and skills to grow into sensitive and
                  socially responsible individuals.{" "}
                </p>
                <p>
                  I am confident that in the years to come the school will play
                  a significant role in moulding responsible citizens, who will
                  not only make their imprints in their chosen fields of
                  interests buts also contribute in bringing about
                  transformational changes in the society and the country at
                  large{" "}
                </p>
                <p>
                  I strongly believe that an investment in school education will
                  pay rich dividends to the society in the long run and it is
                  imperative that all stakeholders contribute to the growth and
                  development of the school. I am confident that through
                  collective effort, the school will be able to serve the
                  community of pupils with devotion and dedication in the years
                  to come. We have put our best foot forward in this endeavour
                  and I am confident that others too will assist in taking the
                  school to greater heights through ceaseless efforts.{" "}
                </p>
                <p>Warm Regards </p>

                <p className="name">
                  Mrs. Vatsala Agarwal<span> Chairperson </span>
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
      <NKRFooter />
    </>
  );
}

export default ChairpersonMessage;
